import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { format } from 'url';
import { createAction, createReducer, createSelector, createCachedSelector } from '@techstyle/redux-core'; // The legacy `url` format/parse API is what Next.js itself uses, so it's what
// we must use too.
// eslint-disable-next-line node/no-deprecated-api

import logger from './logger';
import { normalizePath, RewriteMapping } from './rewritesSchema'; // we can use a placeholder here since we're only consuming parts of the url

var ORIGIN_PLACEHOLDER = 'https://example.tld';
var debug = logger.extend('dynamicRoutesModule');
export var loadRewritesRequest = createAction('routes/loadRewritesRequest');
export var loadRewritesSuccess = createAction('routes/loadRewritesSuccess');
export var loadRewritesFailure = createAction('routes/loadRewritesFailure');
export var loadRouteTypesSuccess = createAction('routes/loadRouteTypesSuccess');
var initialState = {
  enabled: false,
  routeInfoByPath: {},
  routeTypeByPath: {}
};

function initDynamicRoutes(_ref) {
  var routeTypePageMap = _ref.routeTypePageMap,
      builderRoutePageMap = _ref.builderRoutePageMap;
  return function (dispatch, getState, context) {
    if (!process.browser && context.req && !context.hasPreloadedState) {
      var _context$req$context = context.req.context,
          rewrites = _context$req$context.rewrites,
          rewritesEnabled = _context$req$context.rewritesEnabled,
          routeInfo = _context$req$context.routeInfo,
          builderPageModelRoutes = _context$req$context.builderPageModelRoutes;

      if (rewritesEnabled && (rewrites || builderPageModelRoutes)) {
        var routeTypes = {}; // create the routeTypes lookup which is a mapping of route to the corresponding
        // type in rewrites or builder

        if (rewrites || builderPageModelRoutes) {
          // a helper function to retrieve the routes map from our processed rewrites and builderPageModelRoutes
          var getRoutesMap = function getRoutesMap(obj) {
            if (!obj) {
              return {};
            } // Return an empty object if obj is null or undefined.


            return Object.values(obj).reduce(function (routes, _ref2) {
              var canonicalPath = _ref2.canonicalPath,
                  routeType = _ref2.routeType;

              // FIXME: Filter out ColdFusion paths that are invalid for the React
              // app. For now, ignore anything that was normalized to `/`.
              if (canonicalPath !== '/') {
                routes[canonicalPath] = routeType;
              }

              return routes;
            }, {});
          }; // allow rewrites to still trump builder
          // actively deactivate rewrite routes to allow builder to trump them


          var routes = _objectSpread(_objectSpread({}, getRoutesMap(builderPageModelRoutes)), getRoutesMap(rewrites));

          routeTypes = _objectSpread(_objectSpread({}, routeTypes), routes);
        }

        dispatch(loadRouteTypesSuccess(routeTypes));

        if (routeInfo) {
          dispatch(loadRewritesSuccess(null, {
            entities: {
              Rewrite: _defineProperty({}, routeInfo.canonicalPath, routeInfo)
            }
          }));
        }
      }
    }

    if (getState().dynamicRoutes.enabled) {
      context.routeResolvers = context.routeResolvers || [];
      context.routeResolvers.push(createDynamicRoutesResolver({
        getState: getState,
        routeTypePageMap: routeTypePageMap,
        builderRoutePageMap: builderRoutePageMap
      }));
    }
  };
}

export function createDynamicRoutesResolver(_ref3) {
  var getState = _ref3.getState,
      routeTypePageMap = _ref3.routeTypePageMap,
      builderRoutePageMap = _ref3.builderRoutePageMap;
  return function (href, asPath) {
    var state = getState();

    if (typeof href === 'string') {
      var url = {};

      try {
        url = new URL(href, ORIGIN_PLACEHOLDER);
      } catch (err) {
        debug('Error parsing href: %s', href);
      }

      var routeType = getRouteType(state, url.pathname);

      if (routeType) {
        var pathname = routeTypePageMap[routeType] || builderRoutePageMap[routeType];

        if (pathname && pathname !== url.pathname) {
          return {
            href: {
              pathname: pathname,
              hash: url.hash || undefined,
              query: Object.fromEntries(url.searchParams.entries())
            },
            asPath: href
          };
        }
      }
    } else {
      var _href = href,
          _routeType = _href.routeType,
          rest = _objectWithoutProperties(_href, ["routeType"]);

      if (_routeType) {
        // The asPath for this route type.
        var canonicalPath = getRoutePathByType(state, _routeType); // The Next.js pathname for this route type.

        var _pathname = routeTypePageMap[_routeType] || builderRoutePageMap[_routeType];

        if (canonicalPath && _pathname) {
          href = _objectSpread(_objectSpread({}, rest), {}, {
            pathname: _pathname
          });

          if (!asPath) {
            asPath = format(_objectSpread(_objectSpread({}, rest), {}, {
              pathname: canonicalPath
            }));
          }

          return {
            href: href,
            asPath: asPath
          };
        } else {
          throw new Error("No route found for routeType: ".concat(_routeType));
        }
      }
    }
  };
}
export function getResolveRoute() {
  return function (dispatch, getState, context) {
    var _context$routeResolve = context.routeResolvers,
        routeResolvers = _context$routeResolve === void 0 ? [] : _context$routeResolve;
    return function (href, asPath) {
      // Check if each resolver can resolve the route, then fall back to handing
      // it to Next.js as-is.
      var _iterator = _createForOfIteratorHelper(routeResolvers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resolveRoute = _step.value;
          var result = resolveRoute(href, asPath);

          if (result) {
            return result;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        href: href,
        asPath: asPath
      };
    };
  };
}
/**
 * Loads dynamic URL rewrite data.
 * @param {Array} pathnames The URL paths to load
 */

export function loadRewrites() {
  var pathnames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    force: false
  };
  return function (dispatch, getState) {
    var _getState = getState(),
        dynamicRoutes = _getState.dynamicRoutes; // Normalize given pathnames


    var paths = pathnames.map(normalizePath); // Filter out paths that have been requested previously unless any have
    // a feature that is missing feature data.

    if (!options.force) {
      paths = paths.filter(function (path) {
        var _dynamicRoutes$routeI, _dynamicRoutes$routeI2;

        var hasFeature = (_dynamicRoutes$routeI = dynamicRoutes.routeInfoByPath[path]) === null || _dynamicRoutes$routeI === void 0 ? void 0 : _dynamicRoutes$routeI.label;
        var isMissingFeatureData = hasFeature && !((_dynamicRoutes$routeI2 = dynamicRoutes.routeInfoByPath[path]) !== null && _dynamicRoutes$routeI2 !== void 0 && _dynamicRoutes$routeI2.feature);
        return !dynamicRoutes.routeInfoByPath[path] || isMissingFeatureData;
      });
    } // If all paths have been fetched before, then abort fetching


    if (!paths.length) {
      debug('Skipping previously-loaded routes: %o', paths);
      return;
    } else {
      debug('Loading URL rewrite data for routes: %o', paths);
    }

    return dispatch({
      bentoApi: {
        endpoint: 'rewrites/find',
        searchParams: {
          paths: paths.join(',')
        },
        schema: RewriteMapping,
        actions: [loadRewritesRequest, loadRewritesSuccess, loadRewritesFailure]
      }
    });
  };
}
var dynamicRoutesReducer = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, loadRewritesRequest, function (state) {
  return state;
}), _defineProperty(_createReducer, loadRewritesFailure, function (state) {
  return state;
}), _defineProperty(_createReducer, loadRewritesSuccess, function (state, action) {
  // `Rewrite` might not always exist in response, so it needs a default value
  var _action$meta$entities = action.meta.entities.Rewrite,
      rewrites = _action$meta$entities === void 0 ? {} : _action$meta$entities;
  Object.keys(rewrites).forEach(function (pathname) {
    state.routeInfoByPath[pathname] = {
      data: rewrites[pathname]
    };
  });
}), _defineProperty(_createReducer, loadRouteTypesSuccess, function (state, action) {
  state.enabled = true; // This used to completely replace the contents of `routeTypeByPath` with
  // the payload instead of merging it, because (1) we only expected this
  // to happen once, during initialization, so it would never need to update
  // existing data, and (2) even if it did get called multiple times,
  // extending means an old rewrite that no longer exists can never be
  // removed - merging has the ability to add/update new data, but not delete.
  // Now that route types can be added by `assetRoutesExtension`, it needs to
  // merge like below. If rewrites are continuously updated as assets are
  // refreshed, we may need to address the deletion issue.

  state.routeTypeByPath = _objectSpread(_objectSpread({}, state.routeTypeByPath), action.payload);
}), _createReducer));
export var getRewrite = createSelector([function (state) {
  return state.dynamicRoutes.routeInfoByPath;
}, function (state, pathname) {
  return pathname;
}], function (routeInfoByPath, pathname) {
  var canonicalPath = normalizePath(pathname);
  return routeInfoByPath[canonicalPath];
});
export var getRouteType = createSelector([function (state) {
  return state.dynamicRoutes.routeTypeByPath;
}, function (state, pathname) {
  return pathname;
}], function (routeTypeByPath, pathname) {
  var canonicalPath = normalizePath(pathname);
  return routeTypeByPath[canonicalPath];
});
export var getRoutePathByType = createCachedSelector([function (state) {
  return state.dynamicRoutes.routeTypeByPath;
}, function (state, routeType) {
  return routeType;
}], function (routeTypeByPath, routeType) {
  for (var canonicalPath in routeTypeByPath) {
    var routeTypeForPath = routeTypeByPath[canonicalPath];

    if (routeTypeForPath === routeType) {
      return canonicalPath;
    }
  }
})(function (state, routeType) {
  return routeType;
});
export var getRouteInfo = createSelector([getRewrite], function (rewrite) {
  return rewrite && rewrite.data || null;
});
export default function createDynamicRoutesModule(options) {
  return {
    id: 'dynamic-routes',
    reducerMap: {
      dynamicRoutes: dynamicRoutesReducer
    },
    initialActions: [initDynamicRoutes(options)]
  };
}